import { PopupGateway } from '../domain/popup.gateway';
import { PopupPortal } from '../domain/popup.entities';

export class GetPopupUseCase {
    constructor(private gate: PopupGateway) {}

    async execute(): Promise<PopupPortal | null> {
        return await this.gate.getPopup();
    }
}
